import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import {
  selectAllSalesTeams,
  selectAllSalesTeamUsers,
} from '@user/store/salesTeam/slice'
import { ENTITY_TYPES, updateLoadingState } from '@sales-center/common'
import { BulkReassignFormModel, SubmitCallback } from '../typings'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useBulkActionContext } from '../../../BulkActionContext'
import { toast } from '@sales-center/components'

type Params = {
  entityType: ENTITY_TYPES
  onSubmit: SubmitCallback
}

export const useFormActions = (params: Params) => {
  const { onSubmit, entityType } = params

  const allUsers = useSelector(selectAllSalesTeamUsers)

  const appDispatch = useAppDispatch()

  const { selectedRows, dispatch } = useBulkActionContext()

  const salesTeams = useSelector(selectAllSalesTeams)

  const submitHandler = useCallback(
    async (model: BulkReassignFormModel) => {
      const assignee =
        model.assigneeId && model.assigneeId !== 'unassigned'
          ? allUsers.find((x) => x.userId === model.assigneeId)
          : null

      try {
        appDispatch(updateLoadingState('visible'))
        await onSubmit({
          ids: selectedRows.map((x) => Number(x)),
          salesTeamId: model.salesTeamId as number,
          assigneeId:
            model.assigneeId === 'unassigned' ? null : model.assigneeId,
          removeServices: model.removeServices,
          activeOwner: model.assigneeId === 'unassigned' || assignee?.isActive,
        })
        dispatch({ type: 'setActive' })
      } finally {
        appDispatch(updateLoadingState('hidden'))
        toast.success(
          `${
            entityType == ENTITY_TYPES.Lead ? 'Leads' : 'Opportunities'
          } re-assigned.`,
        )
      }
    },
    [allUsers, appDispatch, dispatch, entityType, onSubmit, selectedRows],
  )

  return {
    salesTeams,
    submitHandler,
  }
}
